import { Button } from '@mui/material';

import Snackbar from '../Snackbar';
import { REASON_CLICK_AWAY, REASON_CLICK_CLOSE } from '../../constants/reasons';

export const getOnCloseWrapper = (onClose) => (e, reason) => {
  if (reason === REASON_CLICK_AWAY) {
    return;
  }

  onClose(reason || REASON_CLICK_CLOSE);
};

/**
 * @deprecated
 * ### Description
 * `FlashMessage` has been deprecated and replaced by Classify `Snackbar`.
 *
 * ### Example
 * ```
 * import Snackbar from '@classify/react-core-components/Snackbar';
 * ```
 */
export default function FlashMessage({
  autoCloseDuration = 10000,
  onClose = null,
  canShowCloseButtonOnAutoClose = false,

  translations = {
    close: 'Close',
  },

  ...otherProps
}) {
  let showCloseButton = false;
  let onCloseHandler = null;

  if (onClose) {
    showCloseButton = autoCloseDuration ? canShowCloseButtonOnAutoClose : true;
    onCloseHandler = getOnCloseWrapper(onClose);
  }

  const action = showCloseButton ? (
    <Button color="inherit" size="small" onClick={onCloseHandler}>
      {translations.close}
    </Button>
  ) : null;

  return (
    <Snackbar
      action={action}
      autoCloseDuration={autoCloseDuration}
      onClose={onCloseHandler}
      {...otherProps}
    />
  );
}
